var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pub_tips"},[_c('div',[_vm._v("遇到问题？"),_c('span',{staticClass:"tel"},[_vm._v("请拨打 1-808-940-9995/9996")])]),_c('div',[_c('span',{staticClass:"app"},[_vm._v("WhatsApp 8089409995")])])])
}]

export { render, staticRenderFns }